module.exports = __webpack_public_path__ + "static/media/same-value.9d719f89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/same-value.svg
// module id = 1874
// module chunks = 1